export function getFakePlayerIndicator(playerId: string | null | undefined) {
    if (!playerId || !playerId.includes('fake')) {
        return null
    }

    // Check if it has the pattern fake:player:-{id}
    if (playerId.includes('fake:player:-')) {
        return { show: true, color: '#FAAD14' } // Yellow
    }

    // Check if it has fake:player but without the dash
    if (playerId.includes('fake:player')) {
        return { show: true, color: '#1E3A8A' } // Dark blue
    }

    // Other fake patterns (like front:fake)
    return { show: true, color: '#FAAD14' } // Default yellow
}
